// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const HierarchyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Hierarchy/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.375 7.083a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416ZM4.167 18.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM15.833 18.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.975 13.317a5.774 5.774 0 0 0-5.45-3.875H10.5l-2.942.008a2.826 2.826 0 0 1-2.741-2.075V5.842a.635.635 0 0 0-.642-.634.628.628 0 0 0-.633.634v9.35c0 .35.283.633.633.633a.64.64 0 0 0 .642-.633V9.675a4.118 4.118 0 0 0 2.733 1.05h.017l2.941-.008h.017a4.488 4.488 0 0 1 4.242 3.016.651.651 0 0 0 .816.4.641.641 0 0 0 .392-.816Z"
}));
export default HierarchyIcon;